import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Edit3 } from "lucide-react";
import TestService from "../../../services/KangarooServices/TestService";
import { imageBaseApi } from "../../../utilis/imageHelper";
import SimpleBar from "simplebar-react";

const TestDetail = () => {
  const [data, setData] = useState();
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchDatabyId = async (id) => {
    const res = await TestService.getDetail(id);
    setData(res);
  };

  useEffect(() => {
    fetchDatabyId(id);
  }, [id]);

  const breadcrumbItems = [{ title: "Back to List", link: "/test-preparation" }];

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Detail"
          pageTitle="Test Preparation"
          breadcrumbItems={breadcrumbItems}
        />

        {/* Banner */}
        <div className="position-relative mb-4">
          {data?.media ? (
            <img
              src={`${imageBaseApi}${data.media?.url}`}
              alt={data?.preparationName}
              className="img-fluid w-100 object-fit-contain rounded"
              style={{ height: "300px" }}
            />
          ) : (
            <div
              className="d-flex justify-content-center align-items-center bg-secondary text-white rounded"
              style={{ height: "300px" }}
            >
              <span>No Banner Provided</span>
            </div>
          )}
          <button
            type="button"
            className="btn btn-primary position-absolute top-0 end-0 m-3 d-flex align-items-center gap-1"
            onClick={() => navigate(`/test-preparation/update/${id}`)}
            style={{ fontSize: "0.875rem" }}
          >
            <Edit3 size={14} /> Update
          </button>
        </div>

        {/* Tabs */}
        <Nav tabs className="mb-4">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => toggleTab("1")}
              style={{ cursor: "pointer" }}
            >
              General Info
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => toggleTab("2")}
              style={{ cursor: "pointer" }}
            >
              Test Structures
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          {/* General Info Tab */}
          <TabPane tabId="1">
            <Card className="shadow-sm mb-4">
              <CardBody>
                <div className="mb-3">
                  <h6 className="fw-bold text-uppercase">Heading</h6>
                  <p>{data?.testHeading}</p>
                </div>
                <div className="mb-3">
                  <h6 className="fw-bold text-uppercase">Preparation Name</h6>
                  <p className="text-muted">{data?.preparationName}</p>
                </div>
                <div className="mb-3">
                  <h6 className="fw-bold text-uppercase">Description</h6>
                  <div
                    className="text-muted"
                    dangerouslySetInnerHTML={{ __html: data?.description }}
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      paddingRight: "1rem",
                    }}
                  />
                </div>

                {data?.moreAbout && (
                  <div className="mb-3">
                    <h6 className="fw-bold text-uppercase">More About</h6>
                    <div
                      dangerouslySetInnerHTML={{ __html: data?.moreAbout }}
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        paddingRight: "1rem",
                      }}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </TabPane>

          {/* Test Structures Tab */}
          <TabPane tabId="2">
            {data?.testStructures?.length > 0 ? (
              <Row className="mt-3">
                {data.testStructures.map((structure) => (
                  <Col lg={4} key={structure.id} className="mb-4">
                    <Card className="h-100 shadow-sm">
                      {structure.media && (
                        <img
                          src={`${imageBaseApi}${structure.media.url}`}
                          alt={structure.name}
                          className="mt-3 card-img-top object-fit-contain"
                          style={{ height: "230px" }}
                        />
                      )}
                      <CardBody>
                        <h6 className="fw-bold">{structure.name}</h6>
                        <SimpleBar style={{maxHeight: "200px"}}>
                          <div
                            className="text-muted"
                            dangerouslySetInnerHTML={{
                              __html: structure.description,
                            }}
                            // style={{ maxHeight: "200px", overflowY: "auto" }}
                          />
                        </SimpleBar>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <div className="text-muted p-3">
                No test structures available.
              </div>
            )}
          </TabPane>
        </TabContent>
      </Container>
    </div>
  );
};

export default TestDetail;
